import { kanaList, kanaH2F, kanaF2H } from './kana'

export function idPresentation (id) {
  const digits = 8
  const lastDigits = String(id).slice(-digits)
  return lastDigits.padStart(digits, '0')
}

export function popoverLink (text, content) {
  return `<a class="help-popover" data-toggle="popover" data-content="${content}">${text}</a>`
}

export function contractTypePresentation (typeNum) {
  switch (typeNum) {
    case 1:
    case '1':
      return 'アイテム個別'
    case 2:
    case '2':
      return 'グロス'
    case 0:
    case '0':
      return 'その他'
    case 3:
    case '3':
      return 'クロスリクープ'
    default:
      return typeNum
  }
}

/**
 * arrayをkeyに基づいてグループ分けする
 * @param {array} array 配列
 * @param {func} getKey (elem, i, src) => key
 * @param {bool} toArray trueなら結果を[key, array]の配列で返し、falseならMap型で返す
 * @returns array|Map
 */
export function groupBy (array, getKey, toArray = true) {
  const groupMap = array.reduce((map, elem, i, src) => {
    const key = getKey(elem, i, src)
    const list = map.get(key)
    list ? list.push(elem) : map.set(key, [elem])
    return map
  }, new Map())
  return toArray ? Array.from(groupMap) : groupMap
}

export function clipboardCopy (text) {
  const el = document.createElement('textarea')
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  el.parentElement.removeChild(el)
}

export function getClipboard (onRead) {
  if (navigator && navigator.clipboard) {
    navigator.clipboard.readText().then(function (text) {
      if (text) {
        onRead(text)
      }
    })
  } else {
    alert('申し訳ありません。現在お使いの環境ではマウスからのペーストは許可されていません。\nキーボードで「Ctrl+V」を入力してください。')
  }
}

/**
 * price: 整数、rateDecimal, royality: 第2位までの小数として、次のような小数priceFloatを返す：
 * 1. royality = Math.round(priceFloat * rateDecimal * 100) * 0.01という関係式が成り立つ
 * 2. priceFloatを四捨五入するとpriceと一致する
 * ただし反復計算がmaxIter回を超えた場合は、条件2を無視した値を返す
 */
export function getNearestPrice (price, rateDecimal, royality, maxIter = 100) {
  let [priceL, priceR] = [price - 0.5, price + 0.5]
  function getRoyality (price) {
    return Math.round(price * rateDecimal * 100) * 0.01
  }
  // 値域の左端がroyalityより小さく、右端がroyalityより大きくないと二分法が成立しないので、そうでない場合は条件2を無視した値を返す
  if (getRoyality(priceL) > royality || getRoyality(priceR) < royality) {
    return royality / rateDecimal
  }
  let iter = 0
  while (iter < maxIter) {
    const priceC = (priceL + priceR) / 2
    const diff = getRoyality(priceC) - royality
    if (Math.abs(diff) < 0.001) {
      return priceC
    } else if (diff < 0) {
      priceL = priceC
    } else {
      priceR = priceC
    }

    iter += 1
  }

  return royality / rateDecimal
}

/**
 * 文字列strに含まれる英数字・カタカナの半角と全角を変換する
 * reverse = false（デフォルト）のときは半角→全角、trueのときはその逆の変換を行う
 */
export function convertHarfCharacter (str, reverse = false) {
  const regAbc = reverse ? /[Ａ-Ｚａ-ｚ０-９]/g : /[A-Za-z0-9]/g
  const abcDiff = 0xFEE0
  const regKana = new RegExp('(' + kanaList.map((p) => p[reverse ? 1 : 0]).join('|') + ')', 'g')
  return str
    .replace(regAbc, (match) => String.fromCharCode(match.charCodeAt(0) + abcDiff * (reverse ? -1 : 1)))
    .replace(regKana, (match) => (reverse ? kanaF2H : kanaH2F).get(match))
}

/**
 * 小数同士を誤差なく掛け算する
 * @param {*} a 掛けられる数
 * @param {*} b 掛ける数
 * @param {*} aDecimalPlaces aの小数点以下桁数
 * @param {*} bDecimalPlaces bの小数点以下桁数
 */
export function multiplyDecimals (a, b, aDecimalPlaces, bDecimalPlaces) {
  const aShift = Math.pow(10, aDecimalPlaces)
  const bShift = Math.pow(10, bDecimalPlaces)
  return Math.round(a * aShift) * Math.round(b * bShift) / (aShift * bShift)
}

export function getWithDot (obj, key) {
  let tmp = obj
  const keys = key.split('.')
  keys.forEach((k) => {
    if (!tmp) {
      return undefined
    }
    tmp = tmp[k]
  })
  return tmp
}
